// extracted by mini-css-extract-plugin
export default {"delegateTitle":"delegateTitle___Otxab"};